// @flow

export default {
  '/app/zaps': {
    fetch: () =>
      import(
        /* webpackChunkName: 'dashboard-route' */ 'app/dashboard/asyncRoute'
      ).then(module => module.default),
  },
};
